import { action } from '@/lib/api.js';
import pushChangesQueueItem from '@/redux/actions/pushChangesQueueItem.js';
import workflowActions from '@/screens/workflows/redux/actions/workflowActions';
import { randomId } from '@shared/utils/randomId.js';

const credentialActions = {
  set(payload, opts = {}) {
    return new Promise((resolve) => {
      const credential = { ...payload, credentialId: payload?.credentialId || randomId() };
      const credentialId = credential.credentialId;

      action('PUT_CREDENTIAL', { ...credential, updatedOn: new Date() });
      pushChangesQueueItem('credential', {
        appId: credential?.appId,
        credentialId: credential?.credentialId,
        companyId: credential?.companyId,
        value: credential
      });
      resolve(credentialId);
    });
  },

  deleteCredential({ companyId, credentialId, appId }) {
    return new Promise((resolve) => {
      workflowActions.setMetadata('appEnvironmentConnections', (prev) => {
        const newState = { ...(prev || {}) };
        if (newState[appId]) {
          Object.keys(newState[appId]).forEach((environmentId) => {
            if (newState[appId][environmentId] === credentialId) {
              delete newState[appId][environmentId];
            }
          });

          if (Object.keys(newState[appId]).length === 0) {
            delete newState[appId];
          }
        }
        return newState;
      });
      action('DELETE_CREDENTIAL', { companyId, credentialId, appId });
      pushChangesQueueItem('credential', { operation: 'delete', companyId, credentialId, appId });
      resolve();
    });
  }
};

export default credentialActions;
